// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"3b7b6a82","977":"9a62b3f4"}[chunkId] + ".chunk.js";
};